<ng-container *ngIf="userConsents?.length > 0">
  <apex-box
    [expandable]="true"
    [expanded]="!userConsentedToAll">
    <T
      title
      str="User Consents"
      context="portal"
      _context="portal"></T>

    <div class="df c">
      <ng-container *ngFor="let userConsent of userConsents">
        <div class="ap ambs df jsb ac p-c mat-elevation-z1">
          <div class="df c amr">
            <div class="df ac">
              <mat-slide-toggle
                [checked]="userConsented[userConsent.id]"
                (change)="onChangeConsent(userConsent, $event.checked)">
                {{ userConsent.title }}
              </mat-slide-toggle>
            </div>
            <div class="amt ambs">{{ userConsent.description }}</div>
            <div
              class="caption mat-caption"
              *ngIf="userConsent?.Customer?.name">
              <T
                context="portal"
                _context="portal"
                str="Consent wanted by {customerName}."
                [vars]="{ customerName: userConsent.Customer.name }"></T>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </apex-box>
</ng-container>
